module.exports = __webpack_public_path__ + "img/totally-money.34489d21.svg";